import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer mt-auto py-4">
      <Container>
        <Row className="gy-3 align-items-center">
          <Col md={4}>
            <div className="brand">TechVahini</div>
            <div className="small text-muted">Online earning content in Marathi</div>
          </Col>
          <Col md={4} className="text-md-center">
            <nav className="footer-nav">
              <Link to="/privacy" className="me-3">Privacy Policy</Link>
              <Link to="/terms" className="me-3">Terms & Conditions</Link>
              <a href="https://youtube.com/@TechVahini" target="_blank" rel="noopener noreferrer">YouTube</a>
            </nav>
          </Col>
          <Col md={4} className="text-md-end">
            <div className="small text-muted">© {new Date().getFullYear()} TechVahini. All rights reserved.</div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
